import BackButton from "../BackButton";

function AboutUs(){
    return(
        <>
            <center>It's All about our Beginning Journey....$$$</center>
            <div className='divFlexSpan'>
                <BackButton />
            </div>
        </>
    );
}
export default AboutUs;